import { render } from "./NewTrainingBox.vue?vue&type=template&id=573db216&scoped=true"
import script from "./NewTrainingBox.vue?vue&type=script&lang=js"
export * from "./NewTrainingBox.vue?vue&type=script&lang=js"

import "./NewTrainingBox.vue?vue&type=style&index=0&id=573db216&scoped=true&lang=css"

import exportComponent from "/Users/georgeconstantine/Documents/import/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-573db216"]])

export default __exports__